module.exports = __webpack_public_path__ + "img/conflict.1db01d20.jpg";